import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

const useExport = (data, columns, fileName, tableType, excludeColumns = []) => {
    const getRowsAndColumns = () => {
        const tableRows = [];
        const tableColumns = columns
            .filter(col => !excludeColumns.includes(col.field))
            .map(col => col.headerName || col.label);

        data.forEach((item) => {
            const rowData = columns
                .filter(col => !excludeColumns.includes(col.field))
                .map(col => item[col.field]);
            tableRows.push(rowData);
        });

        return { tableColumns, tableRows };
    };

    const getColumnStyles = () => {
        const columnStyles = {};
        columns.forEach((col, index) => {
            if (!excludeColumns.includes(col.field)) {
                columnStyles[index] = { cellWidth: col.width || 'auto' };
            }
        });
        return columnStyles;
    };

    const exportToPDF = () => {
        const { tableColumns, tableRows } = getRowsAndColumns();
        const doc = new jsPDF();

        autoTable(doc, {
            head: [tableColumns],
            body: tableRows,
            startY: 20,
            theme: "grid",
            headStyles: { fillColor: [22, 160, 133] },
            columnStyles: getColumnStyles()
        });

        doc.save(`${fileName}.pdf`);
    };

    const exportToExcel = () => {
        const { tableColumns, tableRows } = getRowsAndColumns();
        const worksheet = XLSX.utils.aoa_to_sheet([tableColumns, ...tableRows]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const cellStyle = {
            font: { name: "Arial", sz: 12 },
            alignment: { vertical: "center", horizontal: "center" },
            border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } }
            }
        };

        Object.keys(worksheet).forEach((cell) => {
            if (worksheet[cell].t === "s" || worksheet[cell].t === "n") {
                worksheet[cell].s = cellStyle;
            }
        });

        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };

    const exportToCSV = () => {
        const { tableColumns, tableRows } = getRowsAndColumns();
        const worksheet = XLSX.utils.aoa_to_sheet([tableColumns, ...tableRows]);
        const csv = XLSX.utils.sheet_to_csv(worksheet);
        const blob = new Blob([csv], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${fileName}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };



    const handlePrint = () => {
        const tableElement = document.getElementById(tableType === 'dataGrid' ? "dG-table" : "my-table");
        if (!tableElement) {
            console.error("Table element not found");
            return;
        }

        const originalDisplayStyles = [];
        excludeColumns.forEach(field => {
            const elements = tableElement.querySelectorAll(`[data-field="${field}"]`);
            elements.forEach(element => {
                originalDisplayStyles.push({ element, display: element.style.display });
                element.style.display = 'none';
            });
        });

        const printContents = tableElement.outerHTML;

        originalDisplayStyles.forEach(({ element, display }) => {
            element.style.display = display;
        });

        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);

        const iframeDoc = iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(`<html><head><title>Print</title><style>table{border-collapse:collapse;width:100%}th,td{border:1px solid #ccc;padding:6px 10px;text-align:left}thead{background:#16a085;color:#fff}</style></head><body>${printContents}</body></html>`);
        iframeDoc.close();

        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        setTimeout(() => {
            document.body.removeChild(iframe);
        }, 1000);
    };

    return {
        exportToPDF,
        exportToExcel,
        exportToCSV,
        handlePrint
    };
};

export default useExport;
